var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoomSceneryOven({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95,
    height: 121,
    viewBox: "0 0 95 121",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D7D7D7",
    d: "M6 0h83a6 6 0 016 6v115H0V6a6 6 0 016-6z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F4F4F4",
    d: "M.5 120.5h94V6A5.5 5.5 0 0089 .5H6A5.5 5.5 0 00.5 6v114.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7D7D7",
    d: "M0 20h95v80H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F4F4F4",
    d: "M.5 20.5h94v79H.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#D7D7D7",
    width: 85,
    height: 68,
    x: 5,
    y: 25,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 67,
    x: 5.5,
    y: 25.5,
    stroke: "#F4F4F4",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#D7D7D7",
    width: 53,
    height: 5,
    x: 21,
    y: 29,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 4,
    x: 21.5,
    y: 29.5,
    stroke: "#F4F4F4",
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7D7D7",
    d: "M9 37h77v52H9z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F4F4F4",
    d: "M9.5 37.5h76v51h-76z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D7D7D7",
    cx: 13.5,
    cy: 10.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 10.5,
    r: 4,
    stroke: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D7D7D7",
    cx: 69.5,
    cy: 10.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.5,
    cy: 10.5,
    r: 4,
    stroke: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D7D7D7",
    cx: 25.5,
    cy: 10.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 10.5,
    r: 4,
    stroke: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D7D7D7",
    cx: 81.5,
    cy: 10.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81.5,
    cy: 10.5,
    r: 4,
    stroke: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#D7D7D7",
    width: 25,
    height: 15,
    x: 35,
    y: 3,
    rx: 7.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 14,
    x: 35.5,
    y: 3.5,
    stroke: "#F4F4F4",
    rx: 7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomSceneryOven);
export default __webpack_public_path__ + "static/media/RoomSceneryOven.7e9d8dd87ea9541e42cf8e5c408e3a25.svg";
export { ForwardRef as ReactComponent };